import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import {connect} from "react-redux";
import {toast} from "react-toastify";
import {RestaurantTableGroup} from "../../../redux/actions/Modules.Action";
import ApiConnect from "../../../Utils/ApiConnect";

class TableGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      formError: false,
      data: [],
      btnDisable: false,
    };
  }
  componentDidMount() {
    this.fetchTableGroup();
  }
  handleChange(e) {
    const Ndata = { ...this.state.data };
    Ndata[e.target.name] = e.target.value;
    this.setState({ data: Ndata });
  }
  fetchTableGroup() {
    ApiConnect.get("/POS/Restaurant/TableGroup")
      .then((response) => {
        this.props.RestaurantTableGroup(response.data);
      })
      .catch((error) => console.log(error));
  }
  createNewTable(e) {
    e.preventDefault();
    this.setState({ btnDisable: true });
    const Fdata = new FormData();
    Fdata.append("name", this.state.data.name);
    ApiConnect({
      method: "post",
      url: "/POS/Restaurant/NewTableGroup",
      data: Fdata,
    }).then((response) => {
      this.setState({ btnDisable: false });
      if (response.data.status === 201) {
        toast.success(response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          draggableDirection: "y",
        });
        this.setState({ data: [], showModal: false, formError: false });
        this.fetchTableGroup();
      } else if (response.data.status === 406) {
        this.setState({ formError: response.data.message });
      } else {
        toast.error(response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          draggableDirection: "y",
        });
      }
    });
  }
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Table Group</strong>
                </h2>
              </div>
              <div className="right gap-items-2">
                <button
                  className="btn btn-primary  btn-float btn-round"
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <div className="media-list media-list-divided media-list-hover pb-10 bg-white">
                {this.props.TableGroupList.map((group, index) => (
                  <a className="media media-single" href="!#">
                    <span className="title">{group.name}</span>
                    <span className="badge badge-pill badge-secondary">
                      {group.tables || 0}
                    </span>
                    <span className="badge badge-pill badge-danger material-icons-outlined">
                      delete
                    </span>
                  </a>
                ))}
                <div />
              </div>
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">Add New Table</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({ showModal: false })}
                >
                  <span>×</span>
                </button>
              </Modal.Header>
              <form onSubmit={(e) => this.createNewTable(e)}>
                <Modal.Body>
                  <p className="text-danger">{this.state.formError}</p>
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Group Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        onChange={(e) => this.handleChange(e)}
                      />
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={this.state.btnDisable}
                  >
                    Create
                  </button>
                </Modal.Footer>
              </form>
            </Modal.Dialog>
          </Modal>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    TableGroupList: state.Restaurant.TableGroup,
  }),
  { RestaurantTableGroup }
)(TableGroup);
